import { Box } from '@material-ui/core';

import { SButton, SInput, SText } from '@setvi/shared/components';

import { useStyles } from './styles';

interface LocationInputProps {
  value: string;
  disabled: boolean;
  generating: boolean;
  canGenerate: boolean;
  onChange: (value: string) => void;
  onGenerate: () => void;
}

export const LocationInput = ({
  value,
  disabled,
  generating,
  canGenerate,
  onChange,
  onGenerate
}: LocationInputProps) => {
  const classes = useStyles();

  return (
    <Box>
      <SText title="Enter your store's 6 digit Location PIN and click Generate." />
      <SText title="Review the preview, then click Add to Cart." />
      {/* noLineClamp: the clamp's -webkit-box display drops the whitespace
          text nodes around the inline <a>. */}
      <SText
        className={classes.help}
        size="xs"
        maxLines="unset"
        noLineClamp
        fontColor="#5D7083">
        Don’t have your location PIN handy? In your owner portal, select
        Locations in the top navigation bar, then choose your location account.
        Your location PIN will appear in the right panel. Don’t see a PIN? Email{' '}
        <a
          className={classes.link}
          href="mailto:SoftwareSupport@alliancels.com">
          SoftwareSupport@alliancels.com
        </a>{' '}
        before placing your order, and they’ll get it sorted out for you.
      </SText>
      <Box mt={2} className={classes.row}>
        <Box flex={1}>
          <SInput
            newDesign
            value={value}
            placeholder="Enter location"
            disabled={disabled}
            onChange={e => onChange(e.target.value)}
          />
        </Box>
        <SButton
          variant="outlined"
          color="primary"
          loading={generating}
          disabled={!canGenerate}
          onClick={onGenerate}>
          Generate
        </SButton>
      </Box>
    </Box>
  );
};
